import { render, staticRenderFns } from "./Wheel.vue?vue&type=template&id=1bbcefef"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"
import style0 from "./Wheel.vue?vue&type=style&index=0&id=1bbcefef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports